import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ImportarProdutoArquivoRequest } from '../../requests/produto/importar-produto-arquivo.request';
import { ValidacaoImportacaoProdutoResponse } from '../../responses/produto/validacao-importacao-produto.response';
import { ProdutoItemValidacaoStruct } from '../../structs/produto/produto-item-validacao.struct';
import { ReturnStruct } from '../../structs/return.struct';

/**
 * Importação de produtos por planilha (ImportarProdutoOrquestradorController).
 * O orquestrador resolve origem/tipo de item SPED (Motor Fiscal) e fornecedor (Pessoa) e delega à API Produto.
 */
@Injectable({ providedIn: 'root' })
export class ImportarProdutoOrquestradorService extends CommonService {
  private readonly apiUrl = `${environment.urlApiOrquestradorSuprimentos}ImportarProdutoOrquestrador`;

  constructor(private httpClient: HttpClient) {
    super();
  }

  public validar(request: ImportarProdutoArquivoRequest): Observable<ValidacaoImportacaoProdutoResponse> {
    return this.httpClient
      .post<ValidacaoImportacaoProdutoResponse>(`${this.apiUrl}/validar`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public confirmar(itens: ProdutoItemValidacaoStruct[]): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(`${this.apiUrl}/confirmar`, itens, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
